
import { defineComponent } from "vue";
import BonoBannerStripe from "@/components/bono/BonoBannerStripe.vue";
import ImageCard from "@/components/bono/ImageCard.vue";
import Button from "@/components/Button.vue";
import AnchorLink from "@/components/AnchorLink.vue";
import ArrowIcon from "@/components/icons/ArrowIcon.vue";

export default defineComponent({
  components: {
    BonoBannerStripe,
    ImageCard,
    Button,
    ArrowIcon,
  },
  props: {
    withoutIcon: { type: Boolean },
  },
  setup() {
    return {
      baseURL: process.env.BASE_URL,
      AnchorLink,
    };
  },
});
